import { toast } from "react-toastify";
import {
  fetchLocationTypeRequest,
  fetchLocationTypeSuccess,
  fetchLocationTypeFailure,
} from "./reducer";
import { GET_LOCATION_TYPE } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getLocationTypes = () => async (dispatch) => {
  dispatch(fetchLocationTypeRequest());

  try {
    const response = await determineBaseUrlAndPerformApiCall(
      GET_LOCATION_TYPE,
      "GET"
    );

    if (response?.error) {
      dispatch(fetchLocationTypeFailure(response.error.message));
      toast.error(response.error.message);
    } else {
      dispatch(fetchLocationTypeSuccess(response));
    }
  } catch (error) {
    dispatch(fetchLocationTypeFailure("Something went wrong"));
    toast.error("Something went wrong");
  }
};